//React Components and Hooks
import React from 'react';
//Material UI functions
import { makeStyles } from '@mui/styles';
//Material UI Components
import IconButton from '@mui/material/IconButton';
import ClearIcon from '@mui/icons-material/Clear';
import Tooltip from '@mui/material/Tooltip';


const useStyles = makeStyles((theme) => ({

}));

const Cancel = (props)=>{
    const {
        tooltip,
        clickFunction,
    }=props;
    return(
        <Tooltip title={tooltip}>
            <IconButton onClick={clickFunction}>
                <ClearIcon style={{color:"white"}} fontSize="small"/>
            </IconButton>
        </Tooltip>
    )
}

export default Cancel;